/* eslint-disable linebreak-style */
import React from 'react';

export const Header = () => {
  return (
    <header>
      <h1>New Singles & Albums</h1>
    </header>)
}